// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g0_7Z","toggle":"styles_toggle__49c4e","preview":"styles_preview__fHc4u"};